module.exports = __webpack_public_path__ + "media/images/flags/64/Ghana-3ec55e20d9487722e750ca0539b4b15f.png";